/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Modal, Table, Select, Skeleton, Badge } from "antd";
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  StarOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Prompt, useHistory } from "react-router";
// import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import useBeforeUnload from "../../components/Prompting";
import { useDispatch, useSelector } from "react-redux";
import { loadExpensesCategories } from "../../store/expenses/actions";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";

const ExpenseCategory = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const { RangePicker } = DatePicker;

  //state initial
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [pageRouting, setPageRouting] = useState(false);
  const [selectDays, setSelectDays] = useState([]);

  //organisation id from login response

  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  console.log(userId, "userId");
  const salesInvoiceList = { organizationId: organizationId };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadExpensesCategories(salesInvoiceList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { expense_category_list = [] } = useSelector(
    (state) => state.PaymentOut
  );
  const media = useMedia();

  //Custom Fields State values
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  //header columns

  const HeaderData = [
    {
      key: "paymentDate",
      title: <p className="header-sales-invoice font-semibold">Date</p>,
      dataIndex: "paymentDate",
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      key: "categoryName",
      title: (
        <p className="header-sales-invoice font-semibold">Category Name</p>
      ),
      dataIndex: "categoryName",
    },
    {
      key: "expenseAmount",
      title: (
        <p className="header-sales-invoice font-semibold">Expense Amount</p>
      ),
      dataIndex: "expenseAmount",
    },
    {
      key: "status",
      title: <p className="header-sales-invoice font-semibold">Status</p>,
      dataIndex: "status",
    },
  ];

  //purchase rows

  const [expenseRows, setExpenseRows] = useState([
    {
      _id: "",
      key: "",
      categoryName: "",
      paymentDate: "",
      expenseAmount: "",
      status: "",
    },
  ]);

  console.log(expense_category_list, "expense_category_list");
  //data table
  const expenseDataTable =
    expense_category_list && expense_category_list.length > 0
      ? expense_category_list.map((data, index) => {
          return {
            _id: data._id,
            key: index + 1,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            notes: data.notes,
            organizationId: data.organizationId,
            categoryName: data.categoryName,
            expenseAmount: data.expenseAmount,
            status: (
              <Badge
                className={
                  data.status &&
                  data.status &&
                  data.status.statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
                // onClick={() => paymentInvoiceRoutes(data)}
              >
                {data.status && data.status && data.status.statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (expenseDataTable && expenseDataTable.length > 0) {
      setExpenseRows(expenseDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expense_category_list]);

  //data table
  // const hasSelected = selectedRowKeys.length > 0;

  //page load without saving

  useBeforeUnload({
    when: !isEmpty(selectDays),
    message: "Are you sure you want to leave?",
  });
  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Expense Category | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24} className="pb-2 border border-b-1 border-t-0 border-x-0">
          <div className="font-poppins flex pl-[20px] pr-[20px] mt-4">
            <ArrowLeftOutlined
              onClick={() => setPageRouting(true)}
              className="font-bold text-[18px]"
            />
            <h1
              style={{
                fontFamily: "Poppins",
              }}
              className="text-[16px] mt-1 ml-2 font-semibold"
            >
              Expense Category
            </h1>
            <div className="flex bg-[#e9e9e9] ml-3 pl-2 pr-2 p-1 rounded-md border-none">
              <StarOutlined
                // onClick={() => setPageRouting(true)}
                className="font-bold text-[16px] mr-2"
              />
              Favorite
            </div>
          </div>
        </Col>
        <div
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "sales-invoices-main-large-device"
              : windowDimensions.height > 830
              ? "sales-invoices-main-extra-large-device"
              : "sales-invoices-main"
          }
        >
          {/* purchase input section with bulk actions */}
          <Col span={24} className="flex justify-between mt-5 mb-2 pl-4 pr-2">
            <div>
              {loading ? (
                <div
                  style={{
                    marginRight: "10px",
                  }}
                >
                  <Skeleton.Input
                    style={{
                      width: "100%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                </div>
              ) : (
                <Select
                  value={selectDays}
                  onChange={(newValue) => setSelectDays(newValue)}
                  placeholder="Select Days"
                  // options={itemOptions}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[220px] h-[40px]"
                  }
                />
              )}
            </div>
            {/* <div>
              <Button
                // onClick={() => {
                //   toast.success("purchase Created");
                // }}
                style={{
                  fontFamily: "Poppins",
                }}
                className="ml-3 bg-[blueviolet] p-5 text-[white] mr-3"
              >
                Create Expense Category
              </Button>
            </div> */}
          </Col>
          {/* <Col span={24} className="pl-4 pr-4 pb-1">
            {hasSelected ? (
              <Row className="flex justify-between mb-2">
                <Col
                  style={{
                    fontFamily: "Poppins",
                    color: "#ffffff",
                    background: "#4096ff",
                    borderRadius: "10px",
                    padding: "5px 10px",
                  }}
                  className="mb-1"
                  span={4}
                >
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </Col>
                {selectedRowKeys.length > 0 ? (
                  <Col>
                    <Tooltip
                      title="Delete Expense Category"
                      placement="topLeft"
                    >
                      <div
                        onClick={() => setDeletePaymentInModal(true)}
                        className="cursor-pointer border border-1 p-[8px] rounded-md"
                      >
                        <DeleteOutlined className="text-[#eb4e50] text-[16px]" />
                      </div>
                    </Tooltip>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            ) : (
              ""
            )}
          </Col> */}
          <Col
            span={24}
            className={
              media === "xxl"
                ? "pt-14 pr-4 pl-4 sales-invoice-orders mt-2"
                : "pt-5 pr-4 pl-4 sales-invoice-orders  mt-2"
            }
          >
            <Table
              style={{
                overflow: "hidden",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                expenseRows &&
                expenseRows.length > 0 &&
                !isEmpty(expenseRows[0].vendorName)
                  ? expenseRows
                  : []
              }
              rowKey={(record) => record._id}
              rowClassName={"text-[12px]"}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              loading={tableLoading ? true : false}
              showSorterTooltip={"sorter-icon"}
              rowSelection={{
                selectedRowKeys,
                onSelectAll: (selectedRowKeys, selectedRows, row) => {
                  const newSelecteds = selectedRows.map((n) => n._id);
                  setSelectedRowKeys(newSelecteds);
                },
                onSelect: (selectedRowKey, selectedRows, row) => {
                  const selectedIndex = selectedRowKeys.indexOf(
                    selectedRowKey._id
                  );
                  let newSelecteds = [];

                  if (selectedIndex === -1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys,
                      selectedRowKey._id
                    );
                  } else if (selectedIndex === 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(1)
                    );
                  } else if (selectedIndex === selectedRowKeys.length - 1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, -1)
                    );
                  } else if (selectedIndex > 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, selectedIndex),
                      selectedRowKeys.slice(selectedIndex + 1)
                    );
                  }
                  setSelectedRowKeys(newSelecteds);
                },
              }}
              scroll={{ x: 765 }}
            />
          </Col>
        </div>
      </Row>
      {/* Delete purchase modal */}
      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/expenses");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div
          style={{
            fontFamily: "Poppins",
          }}
          className="text-center w-[100%]"
        >
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>
      <Prompt
        when={!isEmpty(selectDays)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </React.Fragment>
  );
};

ExpenseCategory.propTypes = {
  location: PropTypes.any,
};

export default ExpenseCategory;
